import logoCorto from '@/assets/marca/logo-corto.png'
import logoPrimario from '@/assets/marca/logo-primario.png'
import { cn } from '@/lib/cn'

interface LogoProps {
  /** `primario`: isotipo + palabra RASTRO. `corto`: sólo la "A". */
  variante: 'primario' | 'corto'
  className?: string
}

/**
 * Logos oficiales, usados tal cual: sin redibujar ni recolorear (§2).
 * Primario en el ingreso y el encabezado de escritorio; corto en celular.
 */
export function Logo({ variante, className }: LogoProps) {
  if (variante === 'corto') {
    return (
      <img
        src={logoCorto}
        alt="RASTRO"
        className={cn('h-8 w-auto select-none', className)}
        draggable={false}
      />
    )
  }

  return (
    <img
      src={logoPrimario}
      alt="RASTRO"
      className={cn('h-8 w-auto select-none', className)}
      draggable={false}
    />
  )
}

/**
 * Avatar de las integrantes de RASTRO: short logo en blanco sobre círculo
 * negro (§2). El PNG es negro sobre transparente; se invierte con CSS.
 */
export function AvatarRastro({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        'inline-flex size-9 shrink-0 items-center justify-center rounded-full bg-tinta',
        className,
      )}
      aria-label="RASTRO"
    >
      <img
        src={logoCorto}
        alt=""
        className="h-5 w-auto select-none invert"
        draggable={false}
      />
    </span>
  )
}
